import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { LegalDocument } from "@/components/LegalDocument";
import { LegalLinks } from "@/components/LegalLinks";

export default function LegalPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="border-b border-border/60 backdrop-blur-xl bg-background/70 sticky top-0 z-40 print:hidden">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
          <Logo />
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">← Back to Drelik</Link>
        </div>
      </header>
      <main className="flex-1 px-6 py-12 sm:py-16">
        <LegalDocument embedded />
        <div className="max-w-3xl mx-auto mt-12 pt-6 border-t border-border print:hidden">
          <p className="text-xs uppercase tracking-wide text-muted-foreground mb-3">More legal documents</p>
          <LegalLinks />
        </div>
      </main>
    </div>
  );
}
